import {
  getParameterByName,
  getPlatformName,
  initializeFlagsmith,
  logVersion,
  setDefaultTheme,
} from '@va/util/helpers';
import flagsmith from 'flagsmith';
import * as ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/app';

// initializeSentry();
logVersion();
setDefaultTheme();
initializeFlagsmith()?.then(() => {
  const impersonateDataStringified = getParameterByName('impersonateData');
  if (impersonateDataStringified) {
    try {
      const impersonateData = JSON.parse(impersonateDataStringified);

      flagsmith.identify(impersonateData.instanceId, { platform: getPlatformName() });
    } catch (e) {
      console.error(e);
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
